import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../../action';

function Breakdown({
  machineryTransactionList
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => {
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <div className="col-12">
        <table className="css-table table table-borderless table-sm table-striped table-hover">
          <thead className="table-header">
            <tr>
              <td className="font-weight-bold">Year</td>
              <td className="font-weight-bold">Qtr</td>
              <td className="font-weight-bold">Description</td>
              <td className="font-weight-bold">Actual Value</td>
              <td className="font-weight-bold">Assessed Value</td>
              <td className="font-weight-bold">Amount</td>
              <td className="font-weight-bold">Penalty</td>
              <td className="font-weight-bold">Discount</td>
              <td className="font-weight-bold">Total</td>
            </tr>
          </thead>
          <tbody>
            {machineryTransactionList &&
              machineryTransactionList.length <= 0 && (
                <tr className="text-center">
                  <td className="history-color" colSpan="7">No data</td>
                </tr>
              )}
            {machineryTransactionList &&
              machineryTransactionList.attributes.breakdowns.map(item => (
                <tr>
                  <td className="history-color">{_.get(item, 'year')}</td>
                  <td className="history-color">{_.get(item, 'qtr')}</td>
                  <td className="history-color">{_.get(item, 'rate')}</td>
                  <td className="history-color">{_.get(item, 'year')}</td>
                  <td className="history-color">{_.get(item, 'assessed_value')}</td>
                  <td className="history-color">{_.get(item, 'amount')}</td>
                  <td className="history-color">{_.get(item, 'penalty')}</td>
                  <td className="history-color">{_.get(item, 'discount')}</td>
                  <td className="history-color">{_.get(item, 'total_amount')}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </Modal.Body>
  );
}

Breakdown.propTypes = {
  machineryTransactionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(Breakdown);
